'use strict';

var Backbone = require('backbone');
var _ = require('underscore');
var moment = require('moment-timezone');

export default Backbone.Model.extend({

  hasTimes: function () {
    if (!this.has('time')) {
      return false;
    }

    return this.get('time').length > 0;
  },

  hasTime: function (time) {
    return _.some(this.get('time'), function (t) {
      return t.start == time;
    });
  },

  getTime: function (time) {
    if (!this.hasTimes()) {
      return;
    }

    return _.find(this.get('time'), function (t) {
      return t.start == time;
    });
  },

  getFirstTime: function() {
    return moment(this.get('value') + ' ' + this.get('time')[0]['start']);
  },

  isFirstTime: function (time) {
    return this.get('time')[0].start == time;
  },

  isLastTime: function (time) {
    var times = this.get('time');
    return times[times.length - 1].start == time;
  },

  getNextTime: function (time) {
    var timeObject = this.getTime(time);
    var times = this.get('time');
    var timeIndex = _.indexOf(times, timeObject);

    if (timeIndex == times.length - 1) {
      return false;
    }
    return times[timeIndex + 1].start;
  },

  getPreviousTime: function (time) {
    var timeObject = this.getTime(time);
    var times = this.get('time');
    var timeIndex = _.indexOf(times, timeObject);

    if (timeIndex == 0) {
      return false;
    }
    return times[timeIndex - 1].start;
  },
});
